import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProviderPortal from '@/pages/portals/provider/ProviderPortal';
import { Helmet } from 'react-helmet';

const Provider = () => {
  const navigate = useNavigate();

  // Schema markup for healthcare provider portal
  const providerSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "name": "Scienza Health Provider Portal",
    "description": "Secure healthcare provider portal for managing patient cognitive assessments and care plans",
    "audience": {
      "@type": "Audience",
      "audienceType": "Healthcare Providers"
    },
    "specialty": "Cognitive Health",
    "medicalAudience": "Physicians, Healthcare Providers",
    "about": {
      "@type": "Thing",
      "name": "Cognitive Health Assessment and Monitoring"
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Helmet>
        <title>Provider Portal | Scienza Health</title>
        <meta name="description" content="Secure healthcare provider portal for managing patient cognitive assessments and care plans" />
        <script type="application/ld+json">
          {JSON.stringify(providerSchema)}
        </script>
      </Helmet>
      <ProviderPortal />
    </div>
  );
};

export default Provider;